import { IMedia } from "src/model/unityObject";

/**
 * media.metadata can reach the frontend either as a parsed object or as a
 * JSON string (e.g. scenaria-generated medias come back stringified). Always
 * normalise through this helper instead of accessing media.metadata directly,
 * otherwise object-shaped reads silently return undefined on the string case.
 */
const getMediaMetadata = (media: IMedia): Record<string, any> | null => {
  if (!media?.metadata) {
    return null;
  }
  if (typeof media.metadata === "object") {
    return media.metadata as Record<string, any>;
  }
  if (typeof media.metadata === "string") {
    try {
      return JSON.parse(media.metadata);
    } catch (e) {
      console.log("getMediaMetadata: Unable to parse string, is it really a JSON string ?");
    }
  }
  return null;
};

export default getMediaMetadata;
